import React, { useEffect, useState } from 'react';
import './filteredListView.scss';
import PropTypes from 'prop-types';
import { Grid, Box } from '@mui/material';
import SkillMapCard from './SkillMapCard/skillMapCard';
import PaginationButtons from '../../../Components/DataGrid/pagination';
import {
  NO_RECORDS_FOUND,
  SKILL_MAP_DASHBOARD,
} from '../../../Constants/strings';
import NoData from './noData';
import { fetchProfilePic } from '../apiCallUtil';

const ITEMS_PER_PAGE = 8;

const FilteredListView = ({
  filteredValues,
  setFilteredList,
  setLevelFilteredList,
  handleSnackbar,
  activeLevel,
}) => {
  const [filteredSkillMaps, setFilteredSkillMaps] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchData();
    setPage(1);
  }, [filteredValues]);

  const fetchData = async () => {
    const userIds = filteredValues.map((item) => item.userId);
    const profilePics = await fetchProfilePic(userIds);

    // Create a lookup object for profilePics
    const profilePicLookup = profilePics.reduce((acc, pic) => {
      acc[pic.employeeId] = pic.photoSignedUrl;
      return acc;
    }, {});

    // Map the filteredValues array and add the photoSignedUrl
    const updatedFilteredValues = filteredValues.map((item) => {
      return {
        ...item,
        photoSignedUrl: profilePicLookup[item.userId] || null,
      };
    });

    setFilteredSkillMaps(updatedFilteredValues);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const paginatedValues = filteredSkillMaps.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE,
  );

  return (
    <Box>
      <div className="core-skill-container">
        <div className="core-skill-circle"></div>
        <span>{SKILL_MAP_DASHBOARD.CORE_SKILL}</span>
      </div>

      <Box className="skill-map-grid-container">
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 4 }}
          className="skill-map-grid"
        >
          {paginatedValues.map((skillMap) => (
            <Grid
              item
              xs={3}
              sm={3}
              md={3}
              key={skillMap.skillMapId}
              className="skill-map-grid-item"
            >
              <SkillMapCard
                skillMap={skillMap}
                setFilteredList={setFilteredList}
                setLevelFilteredList={setLevelFilteredList}
                handleSnackbar={handleSnackbar}
                activeLevel={activeLevel}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      {paginatedValues.length === 0 && (
        <NoData message={NO_RECORDS_FOUND} displayImage={false} />
      )}

      <PaginationButtons
        currentPage={page}
        pageSize={ITEMS_PER_PAGE}
        paginatedData={paginatedValues}
        filteredSortedData={filteredSkillMaps}
        handlePageChange={handlePageChange}
      />
    </Box>
  );
};

FilteredListView.propTypes = {
  filteredValues: PropTypes.array.isRequired,
  setFilteredList: PropTypes.func.isRequired,
  setLevelFilteredList: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  activeLevel: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]).isRequired,
};

export default FilteredListView;
